import { QUERY_KEYS, SERVER_ROUTES } from "@constants/api.routes";
import type { ProfileUpdateResponse, UpdateProfilePayload } from "../../types";
import { api } from "@config/axios/axios.config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_STATUS } from "@constants/http.status.code";
import { showNotification } from "@libs/notistack/notificationStack";
import { SNACKBAR_SEVERITY } from "@constants/notificationStack";

export const useUpdateProfile = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (data: UpdateProfilePayload) => {
			const response = await api.patch<ProfileUpdateResponse>(SERVER_ROUTES.USER.PROFILE_UPDATE, data);
			return response.data;
		},
		onSuccess: (response: ProfileUpdateResponse) => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER.GET_PROFILE] });

			if (response?.statusCode === HTTP_STATUS.OK || response?.statusCode === HTTP_STATUS.CREATED) {
				if (response?.message) {
					showNotification({
						message: response?.message,
						severity: SNACKBAR_SEVERITY.SUCCESS,
					});
				}
			}
		},
	});
};
